// Shown when a write is refused because the relying party already has an entity with that
// contactEmail. Neither screen offers to jump to the entity holding it, so a different email is
// the only way forward.
export const DUPLICATE_CONTACT_EMAIL_MESSAGE = 'This contact email address is already in use by an '
    + 'existing entity. Please choose a different email.';

// Shown for an import file with no "Entity ID" column, whether that is caught while reading the
// file or when the API rejects the payload.
export const LEGACY_CSV_FORMAT_MESSAGE = 'The bulk import process requires unique identifiers for '
    + 'each entity. Please download a new CSV worksheet template to use with your import.';

// Producers come in only through a Download Data file, which writes them the way the import reads them.
export const PRODUCERS_WORKSHEET_MESSAGE = 'To import producers, upload a Download Data file. The CSV worksheet '
    + 'doesn\'t support the Producers column.';

// The built-in Producers column and such a custom property would share a column name.
export const PRODUCERS_CUSTOM_PROPERTY_MESSAGE = 'This account has a custom property named Producers, so producers '
    + 'can\'t be imported. Remove the Producers column and upload the file again.';

export const PRODUCERS_FLOW_OFF_MESSAGE = 'This account doesn\'t use producers. Remove the Producers column and '
    + 'upload the file again.';

// Shown when a bulk import carries producers. The API emails producers as soon as an entity goes from
// having none to having some, and entity details warns about the same thing before saving.
export const PRODUCERS_EMAIL_NOTICE = 'If an entity had no active producers before this import, its new producers '
    + 'will be emailed right away about any open requirements. Producers are not notified if the entity has no '
    + 'open requirements.';
